/* ============================================================
   Hogwarts Quiz – Ana JS
   Durum makinesi: loading → auth_required | name_input → in_progress → submitting → result
   Kaydedilmiş kullanıcı doğrudan result ekranına gider.
   ============================================================ */

(function () {
  'use strict';

  /* ---- Soru bankası ---- */
  const QUESTIONS = [
    {
      context: 'Bölüm 1 – Hogwarts Mektubu',
      text:   'Bir sabah kapında üzerinde ismin yazılı gizemli bir mektup buluyorsun. Zarfı açtığında Hogwarts\'a kabul edildiğini öğreniyorsun. İçinde heyecan, merak ve biraz da bilinmezlik var.',
      prompt: 'İlk tepkin ne olurdu?',
      choices: [
        { text: 'Hiç düşünmeden hazırlanır, bu maceraya atılırdım.',                            house: 'gryffindor' },
        { text: 'Mektubun her detayını inceler, bunun nasıl mümkün olduğunu anlamaya çalışırdım.', house: 'ravenclaw' },
        { text: 'Önce ailemle ve sevdiklerimle paylaşır, bu anı birlikte yaşamak isterdim.',     house: 'hufflepuff' },
        { text: 'Bu fırsatın bana neler kazandıracağını düşünür, hemen plan yapardım.',          house: 'slytherin'  },
      ],
    },
    {
      context: 'Bölüm 2 – Diagon Alley',
      text:   'Hogwarts\'a gitmeden önce alışveriş için Diagon Alley\'e adım atıyorsun. Etrafında uçan süpürgeler, konuşan kitaplar, parlayan iksir şişeleri ve vitrinlerde büyülü eşyalar var.',
      prompt: 'İlk olarak hangi dükkâna girerdin?',
      choices: [
        { text: 'Kaliteli bir asa ve güçlü büyü ekipmanları satan dükkâna.',                 house: 'gryffindor' },
        { text: 'Eski kitaplar, haritalar ve gizli bilgilerle dolu bir kitapçıya.',           house: 'ravenclaw'  },
        { text: 'Sıcak, samimi ve eğlenceli büyülü eşyalar satan bir dükkâna.',              house: 'hufflepuff' },
        { text: 'Nadir, gösterişli ve herkesin dikkatini çekecek eşyalar satan bir yere.',   house: 'slytherin'  },
      ],
    },
    {
      context: 'Bölüm 3 – Asa Seçimi',
      text:   'Ollivanders\'a giriyorsun. Raflar tavana kadar uzanıyor. Bir asa kutusundan hafif bir ışık sızıyor. Usta asa yapımcısı sana bakıp "Asayı sen seçmezsin, asa seni seçer" diyor.',
      prompt: 'Seni seçen asa nasıl olurdu?',
      choices: [
        { text: 'Güçlü, cesur ve elime aldığım anda enerji veren bir asa.',          house: 'gryffindor' },
        { text: 'Nadir bir çekirdeğe sahip, gizemli ve derin anlamlar taşıyan bir asa.', house: 'ravenclaw'  },
        { text: 'Dengeli, sıcak ve güven veren bir asa.',                            house: 'hufflepuff' },
        { text: 'Zarif, karizmatik ve ilk bakışta etkileyici bir asa.',              house: 'slytherin'  },
      ],
    },
    {
      context: 'Bölüm 4 – Hogwarts Ekspresi',
      text:   'Peron 9¾\'ten geçtin ve Hogwarts Ekspresi\'ne bindin. Kompartımanda farklı öğrenciler var. Bazıları heyecanlı, bazıları sessiz, bazıları ise ilk günden kendini göstermeye çalışıyor.',
      prompt: 'Yolculuk boyunca ne yapardın?',
      choices: [
        { text: 'Yeni insanlarla tanışır, yolculuğu eğlenceli bir maceraya çevirirdim.',             house: 'gryffindor' },
        { text: 'Yanıma aldığım kitapları okur, Hogwarts hakkında daha fazla bilgi edinirdim.',       house: 'ravenclaw'  },
        { text: 'Kompartımandakilerle sohbet eder, herkesin rahat hissetmesini sağlardım.',          house: 'hufflepuff' },
        { text: 'Kimlerin güçlü, zeki veya etkili olduğunu gözlemlerdim.',                          house: 'slytherin'  },
      ],
    },
    {
      context: 'Bölüm 5 – Büyük Salon',
      text:   'Hogwarts\'a vardın. Büyük Salon\'dasın. Tavandaki yıldızlar parlıyor, uzun masalar öğrencilerle dolu. Seçmen Şapka birazdan başına konacak ve hangi binaya ait olduğunu söyleyecek.',
      prompt: 'O an içinden ne geçerdi?',
      choices: [
        { text: '"Neresi olursa olsun, kendimi kanıtlayacağım."',                           house: 'gryffindor' },
        { text: '"Umarım beni gerçekten anlayacak bir yere gönderir."',                     house: 'ravenclaw'  },
        { text: '"Umarım kendimi ait hissedeceğim insanlarla olurum."',                     house: 'hufflepuff' },
        { text: '"Umarım beni potansiyelimi gösterebileceğim bir yere koyar."',             house: 'slytherin'  },
      ],
    },
    {
      context: 'Bölüm 6 – İlk Ders',
      text:   'Hogwarts\'taki ilk dersindesin. Profesör sınıfa zorlu bir büyü gösteriyor ve öğrencilerden denemelerini istiyor. Herkes biraz çekingen, ama denemek için birilerinin öne çıkması gerekiyor.',
      prompt: 'Ne yaparsın?',
      choices: [
        { text: 'İlk deneyenlerden biri olurum. Başarısız olsam bile denemekten çekinmem.',         house: 'gryffindor' },
        { text: 'Önce büyünün mantığını çözmeye çalışır, sonra uygularım.',                         house: 'ravenclaw'  },
        { text: 'Yanımdaki arkadaşlarımla birlikte çalışır, herkesin öğrenmesine yardım ederim.',   house: 'hufflepuff' },
        { text: 'Diğerlerinin hatalarını izler, en doğru anda kusursuz denemek isterim.',           house: 'slytherin'  },
      ],
    },
    {
      context: 'Bölüm 7 – Gizli Koridor',
      text:   'Bir gece Hogwarts\'ta yürürken daha önce fark etmediğin gizli bir koridor buluyorsun. Koridorun sonunda hafifçe aralık duran eski bir kapı var. İçeriden garip bir ışık geliyor.',
      prompt: 'Ne yaparsın?',
      choices: [
        { text: 'Kapıyı açar ve içeride ne olduğunu öğrenirim.',                                    house: 'gryffindor' },
        { text: 'Önce kapının üzerindeki sembolleri ve yazıları incelerim.',                         house: 'ravenclaw'  },
        { text: 'Tek başıma girmem, güvendiğim birkaç arkadaşımı çağırırım.',                       house: 'hufflepuff' },
        { text: 'Kimse fark etmeden burayı nasıl kullanabileceğimi düşünürüm.',                     house: 'slytherin'  },
      ],
    },
    {
      context: 'Bölüm 8 – Hogwarts\'ta İz Bırakmak',
      text:   'Dönemin sonuna yaklaşıyorsun. Hogwarts artık sana yabancı gelmiyor. Arkadaşların, derslerin, maceraların ve öğrendiklerinle burada kendine bir yer edindin.',
      prompt: 'Hogwarts\'ta nasıl hatırlanmak isterdin?',
      choices: [
        { text: 'Cesaretiyle herkese ilham veren biri olarak.',                    house: 'gryffindor' },
        { text: 'Bilgeliği ve zekâsıyla fark yaratan biri olarak.',                house: 'ravenclaw'  },
        { text: 'Dostluğu, sadakati ve iyi kalbiyle sevilen biri olarak.',         house: 'hufflepuff' },
        { text: 'Gücü, karizması ve başarılarıyla iz bırakan biri olarak.',        house: 'slytherin'  },
      ],
    },
  ];

  /* Son soru için ek puan çarpanı */
  const LAST_Q_MULTIPLIER = 2;

  /* House fallback gradientleri (admin görsel yüklemediyse) */
  const HOUSE_GRADIENTS = {
    gryffindor: ['#6b0000', '#2a1800'],
    ravenclaw:  ['#0E1A40', '#1a2c5c'],
    hufflepuff: ['#1A120B', '#3d2d0a'],
    slytherin:  ['#0a2414', '#1A472A'],
  };

  /* ============================================================
     HogwartsQuiz — Ana sınıf
  ============================================================ */
  class HogwartsQuiz {
    constructor(rootEl) {
      this.root = rootEl;
      this.cfg  = window.hqConfig  || {};
      this.houses = (window.hqHouses || []).reduce((acc, h) => { acc[h.key] = h; return acc; }, {});

      this.state = {
        screen:      'loading',
        qIndex:      0,
        answers:     [],           // orijinal şık index'i (soru başına)
        shuffles:    {},           // soru başına karıştırılmış şık sırası
        displayName: '',
        result:      null,         // { house, houseConfig, discountCode }
        storyCanvas: null,
      };

      this._bindRoot();
      this._init();
    }

    /* ---- Init ---- */
    _init() {
      if (!this.cfg.loggedIn) {
        this._go('auth_required');
        return;
      }

      /* 1) Backend'de kayıtlı sonuç var mı? (müşteri metafield — her cihazda geçerli) */
      const done = this.cfg.completed === true || this.cfg.completed === 'true';
      if (done && this.houses[this.cfg.house]) {
        const houseConfig = this.houses[this.cfg.house];
        this.state.displayName = this.cfg.savedName || this.cfg.customerName || '';
        this.state.result = {
          house: this.cfg.house,
          houseConfig,
          discountCode: this.cfg.discountCode || houseConfig.discountCode || '',
          fromCache: true,
        };
        this._go('result');
        return;
      }

      /* 2) Bu tarayıcıda kayıt var mı? (backend erişilemezse yedek) */
      const saved = this._loadSaved();
      if (saved && this.houses[saved.house]) {
        const houseConfig = this.houses[saved.house];
        this.state.displayName = saved.displayName || this.cfg.customerName || '';
        this.state.result = {
          house: saved.house,
          houseConfig,
          discountCode: saved.discountCode || houseConfig.discountCode || '',
          fromCache: true,
        };
        this._go('result');
        return;
      }

      this.state.displayName = this.cfg.customerName || '';
      this._go('name_input');
    }

    /* ---- localStorage tabanlı sonuç saklama ---- */
    _storageKey() {
      return 'hq_result_' + (this.cfg.customerId || 'guest') + '_v' + (this.cfg.quizVersion || '1.0');
    }

    _loadSaved() {
      try {
        const raw = localStorage.getItem(this._storageKey());
        if (!raw) return null;
        const d = JSON.parse(raw);
        return (d && d.house) ? d : null;
      } catch {
        return null;
      }
    }

    _save(house, discountCode) {
      try {
        localStorage.setItem(this._storageKey(), JSON.stringify({
          house,
          discountCode,
          displayName: this.state.displayName,
          completedAt: new Date().toISOString(),
          quizVersion: this.cfg.quizVersion || '1.0',
        }));
      } catch {
        /* localStorage kapalıysa sessizce geç — sonuç yine gösterilir */
      }
    }

    /* ---- Screen router ---- */
    _go(screen) {
      this.state.screen = screen;
      this._render();
    }

    _render() {
      const screens = this.root.querySelectorAll('.hq-screen');
      screens.forEach(s => s.classList.remove('hq-active'));

      const target = this.root.querySelector(`[data-screen="${this.state.screen}"]`);
      if (!target) return;

      target.classList.add('hq-active');
      this._populate(target);
    }

    _populate(el) {
      switch (this.state.screen) {
        case 'auth_required': this._buildAuth(el);        break;
        case 'name_input':    this._buildNameInput(el);   break;
        case 'in_progress':   this._buildQuestion(el);    break;
        case 'submitting':    /* static */                break;
        case 'result':        this._buildResult(el);      break;
      }
    }

    /* ----------------------------------------------------------------
       AUTH REQUIRED
    ---------------------------------------------------------------- */
    _buildAuth(el) {
      el.querySelector('.hq-login-btn').href    = this.cfg.loginUrl;
      el.querySelector('.hq-register-btn').href = this.cfg.registerUrl;
    }

    /* ----------------------------------------------------------------
       NAME INPUT
    ---------------------------------------------------------------- */
    _buildNameInput(el) {
      const input = el.querySelector('#hq-name-input');
      if (this.state.displayName) {
        input.value = this.state.displayName;
      }
      input.focus();

      el.querySelector('#hq-name-form').onsubmit = (e) => {
        e.preventDefault();
        this._handleNameSubmit(el, input);
      };
    }

    _handleNameSubmit(el, input) {
      const val = input.value.trim().replace(/<[^>]*>/g, '');
      const errEl = el.querySelector('#hq-name-error');

      if (val.length < 2) {
        errEl.textContent = 'En az 2 karakter gir.';
        input.focus();
        return;
      }
      if (val.length > 40) {
        errEl.textContent = 'En fazla 40 karakter olabilir.';
        input.focus();
        return;
      }

      errEl.textContent = '';
      this.state.displayName = val;
      this.state.qIndex  = 0;
      this.state.answers  = [];
      this.state.shuffles = {};
      this._go('in_progress');
    }

    /* ----------------------------------------------------------------
       QUESTION
    ---------------------------------------------------------------- */
    _buildQuestion(el) {
      const qi  = this.state.qIndex;
      const q   = QUESTIONS[qi];
      const pct = Math.round((qi / QUESTIONS.length) * 100);

      el.querySelector('.hq-progress-fill').style.width  = pct + '%';
      el.querySelector('.hq-progress-current').textContent = qi + 1;
      el.querySelector('.hq-progress-total').textContent   = QUESTIONS.length;
      el.querySelector('.hq-q-context').textContent        = q.context;
      el.querySelector('.hq-q-text').textContent           = q.text;
      el.querySelector('.hq-q-prompt').textContent         = q.prompt;

      const choicesEl = el.querySelector('.hq-choices');
      choicesEl.innerHTML = '';

      const letters = ['A', 'B', 'C', 'D'];
      const savedAnswer = this.state.answers[qi];

      /* Şık sırasını bir kez karıştır ve oturum boyunca sabit tut
         (her şık kendi binasını taşıdığından puanlama etkilenmez;
          geri/ileri gidince sıra aynı kalır) */
      if (!this.state.shuffles[qi]) {
        this.state.shuffles[qi] = this._shuffle([0, 1, 2, 3]);
      }
      const order = this.state.shuffles[qi];

      order.forEach((origIdx, pos) => {
        const choice = q.choices[origIdx];
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hq-choice' + (savedAnswer === origIdx ? ' hq-selected' : '');
        btn.dataset.orig = origIdx;
        btn.innerHTML = `
          <span class="hq-choice-letter">${letters[pos]}</span>
          <span>${this._esc(choice.text)}</span>
        `;
        btn.addEventListener('click', () => this._selectChoice(origIdx));
        choicesEl.appendChild(btn);
      });

      this._updateNav(el);

      const backBtn = el.querySelector('#hq-back-btn');
      if (backBtn) {
        backBtn.style.display = qi === 0 ? 'none' : '';
        backBtn.onclick = () => {
          this.state.qIndex--;
          this._buildQuestion(el);
        };
      }
    }

    _selectChoice(origIdx) {
      const el = this.root.querySelector('[data-screen="in_progress"]');
      const qi = this.state.qIndex;

      this.state.answers[qi] = origIdx;

      el.querySelectorAll('.hq-choice').forEach((btn) => {
        btn.classList.toggle('hq-selected', Number(btn.dataset.orig) === origIdx);
      });

      this._updateNav(el);
    }

    /* Fisher-Yates karıştırma */
    _shuffle(arr) {
      const a = arr.slice();
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    }

    _updateNav(el) {
      const qi      = this.state.qIndex;
      const hasAns  = this.state.answers[qi] !== undefined;
      const isLast  = qi === QUESTIONS.length - 1;
      const nextBtn = el.querySelector('#hq-next-btn');

      nextBtn.disabled = !hasAns;
      nextBtn.textContent = isLast ? 'Sonucu Gör →' : 'Devam Et →';

      nextBtn.onclick = () => {
        if (!hasAns) return;
        if (isLast) {
          this._submitQuiz();
        } else {
          this.state.qIndex++;
          this._buildQuestion(el);
        }
      };
    }

    /* ----------------------------------------------------------------
       SCORING
    ---------------------------------------------------------------- */
    _calcResult() {
      const scores = { gryffindor: 0, ravenclaw: 0, hufflepuff: 0, slytherin: 0 };

      QUESTIONS.forEach((q, qi) => {
        const ci = this.state.answers[qi];
        if (ci === undefined) return;
        const house  = q.choices[ci].house;
        const weight = qi === QUESTIONS.length - 1 ? LAST_Q_MULTIPLIER : 1;
        scores[house] += weight;
      });

      /* Kazanan bul */
      let winner = null;
      let maxScore = -1;

      for (const [h, s] of Object.entries(scores)) {
        if (s > maxScore) { maxScore = s; winner = h; }
        else if (s === maxScore) {
          /* Beraberlik: 8. sorunun cevabı belirleyici */
          const tieHouse = QUESTIONS[QUESTIONS.length - 1].choices[this.state.answers[QUESTIONS.length - 1]]?.house;
          if (tieHouse === h) winner = h;
          /* Hâlâ beraberlik: deterministik sıra */
          else if (!['gryffindor','ravenclaw','hufflepuff','slytherin'].includes(winner)) {
            winner = h;
          }
        }
      }

      return winner;
    }

    /* ----------------------------------------------------------------
       SUBMIT — sonucu hesapla, tarayıcı hafızasına kaydet, göster
       (Sunucu/backend yok; her şey istemci tarafında.)
    ---------------------------------------------------------------- */
    _submitQuiz() {
      this._go('submitting');

      const house = this._calcResult();
      const houseConfig = this.houses[house] || {};
      const discountCode = houseConfig.discountCode || '';

      /* Tarayıcı hafızasına kaydet (garantili yedek) */
      this._save(house, discountCode);

      /* Müşteri hesabına kaydet (best-effort; sonucu bloklamaz) */
      this._saveToBackend(house);

      this.state.result = { house, houseConfig, discountCode };

      /* "Seçmen Şapka karar veriyor" geçiş efekti için kısa bekleme */
      setTimeout(() => this._go('result'), 900);
    }

    _saveToBackend(house) {
      const endpoint = this.cfg.apiEndpoint;
      if (!endpoint || !this.cfg.customerId) return;
      try {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customerId:  this.cfg.customerId,
            house:       house,
            displayName: this.state.displayName,
            quizVersion: this.cfg.quizVersion || '1.0',
          }),
          keepalive: true,
        }).catch(() => {});
      } catch { /* sessizce geç — sonuç zaten gösteriliyor */ }
    }

    /* ----------------------------------------------------------------
       RESULT
    ---------------------------------------------------------------- */
    _buildResult(el) {
      const { house, houseConfig, discountCode } = this.state.result;
      const name = this.state.displayName || this.cfg.customerName || '';

      /* House banner rengi (light kart üzerinde okunur koyu tonlar) */
      const banner = el.querySelector('.hq-result-house-banner');
      const colors = { gryffindor: '#740001', ravenclaw: '#0E1A40', hufflepuff: '#946B2D', slytherin: '#1A472A' };
      banner.style.setProperty('--hq-house-color', colors[house] || '#171717');

      el.querySelector('.hq-result-announcement').textContent =
        `Seçmen Şapka kararını verdi, ${name}!`;
      el.querySelector('.hq-result-house-name').textContent =
        (houseConfig.label || house) + ' binasına aitsin.';
      el.querySelector('.hq-result-description').textContent =
        houseConfig.resultDescription || '';

      /* Discount */
      el.querySelector('.hq-discount-code-text').textContent = discountCode;

      const copyBtn = el.querySelector('.hq-copy-btn');
      copyBtn.onclick = () => this._copyCode(copyBtn, discountCode);

      /* CTA link */
      const ctaLink = el.querySelector('.hq-cta-link');
      const colHandle = houseConfig.collectionHandle || house;
      ctaLink.href = `/discount/${discountCode}?redirect=/collections/${colHandle}`;
      ctaLink.querySelector('.hq-cta-text').textContent =
        houseConfig.ctaText || `${houseConfig.label || house} Ürünlerini Keşfet`;

      /* Story görseli */
      this._buildStory(el, house, houseConfig, name);

      /* Bina dağılımı istatistiği (backend'den) */
      this._loadStats(el, house);
    }

    /* ----------------------------------------------------------------
       İSTATİSTİK – bina dağılımı
    ---------------------------------------------------------------- */
    async _loadStats(el, myHouse) {
      const endpoint = this.cfg.apiEndpoint;
      const section = el.querySelector('.hq-stats-section');
      if (!endpoint || !section) return;

      try {
        /* CDN önbelleğini atlamak için taze parametre — her ziyaret güncel veri */
        const url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now();
        const resp = await fetch(url, { method: 'GET' });
        if (!resp.ok) return;
        const data = await resp.json();
        if (!data || !Array.isArray(data.stats) || !data.total) return;
        this._renderStats(el, data, myHouse);
      } catch { /* istatistik alınamazsa blok gizli kalır */ }
    }

    _renderStats(el, data, myHouse) {
      const section = el.querySelector('.hq-stats-section');
      const list = el.querySelector('.hq-stats-list');
      const colors = { gryffindor: '#740001', ravenclaw: '#0E1A40', hufflepuff: '#946B2D', slytherin: '#1A472A' };

      const sorted = data.stats.slice().sort((a, b) => b.percent - a.percent);

      list.innerHTML = sorted.map((s) => {
        const label = (this.houses[s.house] && this.houses[s.house].label) || s.house;
        const c = colors[s.house] || '#171717';
        const mine = s.house === myHouse ? ' hq-stat-mine' : '';
        return `
          <div class="hq-stat-row">
            <div class="hq-stat-head">
              <span class="hq-stat-name${mine}">${this._esc(label)}</span>
              <span class="hq-stat-pct" style="color:${c}">%${s.percent}</span>
            </div>
            <div class="hq-stat-bar"><div class="hq-stat-fill" data-w="${s.percent}" style="background-color:${c}"></div></div>
          </div>`;
      }).join('');

      const totalEl = el.querySelector('.hq-stats-total');
      if (totalEl) totalEl.textContent = `Toplam ${data.total} kişi testi çözdü`;

      section.hidden = false;

      /* Kademeli dolum animasyonu — barlar sırayla soldan sağa dolar */
      setTimeout(() => {
        list.querySelectorAll('.hq-stat-fill').forEach((f, i) => {
          f.style.transitionDelay = (i * 0.1) + 's';
          f.style.width = (f.dataset.w || 0) + '%';
        });
      }, 80);
    }

    _copyCode(btn, code) {
      navigator.clipboard.writeText(code).then(() => {
        btn.textContent = '✓ Kopyalandı';
        btn.classList.add('hq-copied');
        setTimeout(() => {
          btn.textContent = 'Kopyala';
          btn.classList.remove('hq-copied');
        }, 2000);
      });
    }

    /* ----------------------------------------------------------------
       STORY CANVAS
    ---------------------------------------------------------------- */
    _buildStory(el, house, houseConfig, name) {
      const previewWrap = el.querySelector('.hq-story-preview-wrap');
      if (!previewWrap) return;

      const canvas = document.createElement('canvas');
      canvas.width  = 1080;
      canvas.height = 1920;
      this.state.storyCanvas = canvas;

      previewWrap.innerHTML = '';
      previewWrap.appendChild(canvas);

      this._drawStory(canvas, house, houseConfig, name);

      /* Download butonu */
      const dlBtn = el.querySelector('.hq-download-btn');
      if (dlBtn) {
        dlBtn.onclick = () => this._downloadStory(canvas, house);
      }

      /* Share butonu */
      const shareBtn = el.querySelector('.hq-share-btn');
      if (shareBtn) {
        if (!navigator.share) {
          shareBtn.style.display = 'none';
          if (dlBtn) dlBtn.style.flex = '1';
        } else {
          shareBtn.onclick = () => this._shareStory(canvas, houseConfig, name);
        }
      }
    }

    async _drawStory(canvas, house, houseConfig, name) {
      const ctx = canvas.getContext('2d');
      const W = 1080, H = 1920;

      /* 1. Arka plan */
      if (houseConfig.storyBackground) {
        try {
          await this._drawCrossOriginImage(ctx, houseConfig.storyBackground, 0, 0, W, H);
        } catch {
          this._drawGradient(ctx, house, W, H);
        }
      } else {
        this._drawGradient(ctx, house, W, H);
      }

      /* 2. Çerçeve içini okunur kılan yumuşak merkez karartması
            (kenarlardaki dekoratif çerçeve korunur) */
      const dark = ctx.createRadialGradient(W / 2, 1020, 180, W / 2, 1020, 820);
      dark.addColorStop(0, 'rgba(8,10,24,0.62)');
      dark.addColorStop(1, 'rgba(8,10,24,0)');
      ctx.fillStyle = dark;
      ctx.fillRect(0, 0, W, H);

      ctx.textAlign = 'center';

      /* Metin bloğu çerçevenin içinde, merkez-alt konumda akar */
      let y = 870;

      ctx.fillStyle = '#E8C87A';
      ctx.font = '600 42px Inter, Arial, sans-serif';
      ctx.fillText('Seçmen Şapka kararını verdi!', W / 2, y);
      y += 108;

      ctx.fillStyle = '#FFFFFF';
      ctx.font = '700 64px Inter, Arial, sans-serif';
      y = this._wrapText(ctx, name + ',', W / 2, y, 700, 76);
      y += 80;

      ctx.fillStyle = '#E8C87A';
      ctx.font = '700 70px Inter, Arial, sans-serif';
      y = this._wrapText(ctx, (houseConfig.label || house) + ' binasına aitsin.', W / 2, y, 740, 80);
      y += 104;

      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.font = '40px Inter, Arial, sans-serif';
      this._wrapText(ctx, houseConfig.storyShortText || '', W / 2, y, 700, 56);

      /* Footer — çerçevenin alt iç kısmında */
      ctx.fillStyle = 'rgba(255,255,255,0.8)';
      ctx.font = '34px Inter, Arial, sans-serif';
      ctx.fillText('Sen de hangi binadan olduğunu keşfet!', W / 2, 1560);

      ctx.fillStyle = '#FFFFFF';
      ctx.font = '700 42px Inter, Arial, sans-serif';
      ctx.fillText('sihirdukkani.com', W / 2, 1632);
    }

    _drawGradient(ctx, house, W, H) {
      const stops = HOUSE_GRADIENTS[house] || ['#1a1a2e', '#0d0d1a'];
      const grad = ctx.createLinearGradient(0, 0, 0, H);
      grad.addColorStop(0, stops[0]);
      grad.addColorStop(1, stops[1]);
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, W, H);
    }

    _drawCrossOriginImage(ctx, url, x, y, w, h) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload  = () => { ctx.drawImage(img, x, y, w, h); resolve(); };
        img.onerror = reject;
        img.src = url;
      });
    }

    _wrapText(ctx, text, cx, startY, maxWidth, lineHeight) {
      if (!text) return startY;
      const words = text.split(' ');
      let line = '';
      let y = startY;

      for (const word of words) {
        const test = line ? line + ' ' + word : word;
        if (ctx.measureText(test).width > maxWidth && line) {
          ctx.fillText(line, cx, y);
          line = word;
          y += lineHeight;
        } else {
          line = test;
        }
      }
      if (line) ctx.fillText(line, cx, y);
      return y;
    }

    _downloadStory(canvas, house) {
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const a   = document.createElement('a');
        a.href     = url;
        a.download = `hogwarts-${house}-sonucum.png`;
        a.click();
        setTimeout(() => URL.revokeObjectURL(url), 5000);
      }, 'image/png');
    }

    async _shareStory(canvas, houseConfig, name) {
      try {
        const blob = await new Promise(r => canvas.toBlob(r, 'image/png'));
        const file = new File([blob], `hogwarts-${houseConfig.key}-sonucum.png`, { type: 'image/png' });

        const shareData = {
          title: 'Hangi Hogwarts Binasındansın?',
          text:  `Seçmen Şapka kararını verdi! Ben ${houseConfig.label} binasından olduğumu öğrendim. Sen de hangi binadan olduğunu keşfet!`,
          url:   window.location.href,
        };

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          shareData.files = [file];
        }

        await navigator.share(shareData);
      } catch (err) {
        if (err.name !== 'AbortError') {
          this._downloadStory(canvas, houseConfig.key || 'hogwarts');
        }
      }
    }

    /* ---- Helpers ---- */
    _esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    _bindRoot() {
      /* Root tıklama olaylarını delegasyonla yakala (future-proof) */
    }
  }

  /* ---- Boot ---- */
  function boot() {
    const root = document.getElementById('hq-root');
    if (!root) return;
    new HogwartsQuiz(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
